import { Callout } from './components/callout.tsx'

export const meta = () => [
	{ title: 'Notifications · xcelera docs' },
	{
		name: 'description',
		content:
			'Configure notification levels for audit failures, score regressions, and completions, delivered by email or webhook.',
	},
]

# Notifications

xcelera can notify you when audits complete, fail, or detect performance regressions. Notifications are delivered via email and [webhooks](/docs/webhooks).

## Notification types

- **Audit failed** — the audit encountered an error (page unreachable, timeout, etc.)
- **Score regressed** — the performance score dropped by 5 or more points compared to the previous audit
- **Audit completed** — the audit finished successfully

## Notification levels

Control which notifications you receive by setting a notification level:

| Level        | What you receive                       |
| ------------ | -------------------------------------- |
| **Critical** | Audit failures only                    |
| **Warning**  | Failures + score regressions (default) |
| **All**      | Every audit result                     |
| **Off**      | Nothing                                |

Each level includes everything from the levels above it. For example, **Warning** includes all **Critical** notifications plus score regressions.

## Setting your level

Configure your global notification level in **Settings → Notifications**. This applies to all pages by default.

### Per-page overrides

You can override the global level for individual pages. This is useful when you want more or fewer notifications for specific pages — for example, **All** for your homepage but **Critical** for a low-priority staging page.

Per-page overrides are set from the page's notification settings.

## Email notifications

Notifications are sent to your account email. You can suppress emails from **Settings → Notifications** if you only want to receive webhook notifications.

<Callout type="info">
	If you stop receiving emails, check your notification settings — emails may
	have been automatically suppressed due to delivery issues. You can re-enable
	them from the same settings page.
</Callout>

## Webhook notifications

For programmatic integrations (Slack, PagerDuty, custom dashboards), set up [webhooks](/docs/webhooks) to receive notifications as HTTP POST requests.
